var Ratio;
(function (Ratio) {
    Ratio["HD"] = "16:9";
    Ratio["WIDE"] = "2.39:1";
    Ratio["SQUARE"] = "1:1";
    Ratio["VERTICAL"] = "4:5";
    Ratio["ORIGINAL"] = "original";
    // The 4:3 aspect ratio is for dev use only. Editors should not be able to select it.
    Ratio["NORMAL"] = "4:3";
    Ratio["SIXTOFIVE"] = "6:5";
})(Ratio || (Ratio = {}));
const ratioKeys = Object.keys(Ratio);
const ratioValues = ratioKeys.map((ratio) => Ratio[ratio]);
var Position;
(function (Position) {
    Position["TOP"] = "top";
    Position["CENTER"] = "center";
    Position["BOTTOM"] = "bottom";
})(Position || (Position = {}));
const positionKeys = Object.keys(Position);
const positionValues = positionKeys.map((position) => Position[position]);
var WidthGetterAlgorithm;
(function (WidthGetterAlgorithm) {
    // Uses the displayed Width: https://developer.mozilla.org/en-US/docs/Web/API/Element/getBoundingClientRect
    WidthGetterAlgorithm[WidthGetterAlgorithm["WITH_TRANSFORM"] = 0] = "WITH_TRANSFORM";
    // Uses the original Width: https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/offsetWidth
    WidthGetterAlgorithm[WidthGetterAlgorithm["WITHOUT_TRANSFORM"] = 1] = "WITHOUT_TRANSFORM";
})(WidthGetterAlgorithm || (WidthGetterAlgorithm = {}));
var ImageEvents;
(function (ImageEvents) {
    ImageEvents["IMAGE_HEIGHT_UPDATED"] = "image-height-updated";
})(ImageEvents || (ImageEvents = {}));

export { ImageEvents as I, Position as P, Ratio as R, WidthGetterAlgorithm as W, ratioKeys as a, positionKeys as b, positionValues as p, ratioValues as r };

//# sourceMappingURL=roche-image.types.js.map